import { render } from "./staff-holiday.vue?vue&type=template&id=1a0e84b0"
import script from "./staff-holiday.vue?vue&type=script&lang=js"
export * from "./staff-holiday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__